module.exports = __webpack_public_path__ + "img/ic_notice.bf1819ec.svg";